__turbopack_context__.v({
  "card": "component-module__AunpJq__card",
});
